import PropTypes from 'prop-types';
import { screen } from 'components/styles/variables';
import { fullWidth } from 'components/styles';
import { useTranslation } from 'react-i18next';

function generateMapUrl(address) {
  return `https://www.google.com/maps/search/?api=1&query=${address}`;
}

export default function StaticMap({ url, address, className = '', onClick }) {
  const mapUrl = generateMapUrl(address);
  const { t } = useTranslation();

  return (
    <a
      href={mapUrl}
      target="_blank"
      aria-label={t('accessibility.newWindow')}
      rel="nofollow"
      onClick={onClick}
      className={`map-container ${className} ${fullWidth.className}`}
    >
      <style jsx>{`
        .map-container {
          display: block;
          background-image: url(${url});
          background-position: center;
          background-repeat: no-repeat;
          background-color: white;
          height: 240px;
          background-size: 768px 768px;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .map-container {
            width: 375px;
          }
        }
      `}</style>
      {fullWidth.styles}
    </a>
  );
}

StaticMap.propTypes = {
  url: PropTypes.string.isRequired,
  address: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
